import PlaylistPersonalized from './PlaylistPersonalized';

export default PlaylistPersonalized;
